import React, { Component, PropTypes } from "react"
import { Link } from "react-router"
import { Button, Col, InputGroup, FormInput } from "elemental"
import { formatPrice } from "theme/components/Price/Price"
import Price from "../Price/Price"
import { translate } from "translate"
import "./ProductColDetail.scss"
import ButtonLove from "../Button/ButtonLove"
import Badge from "../Product/Badge"
import _ from "lodash"
import shop from "../../shop/shop"

const Quantity = ( { quantities } ) => {
  const ve = quantities.map( ( qty ) => qty.multi )
  const veList = ve.join( ", " )
  
  return (
    <span>
      <strong>{translate( "shop.VE" )}:</strong> {veList}
    </span>
  )
}

Quantity.propTypes = {
  quantities: PropTypes.array.isRequired
}

class ProductColDetail extends Component {
  state = {
    imageIndex: 0,
    count     : 1
  }
  
  setCount = ( count ) => {
    count = Number( count )
    count = Math.max( 0, count )
    if ( _.isNaN( count ) ) return
    this.setState( { count } )
  }
  
  addToCart = () => {
    const { product } = this.props
    product.count = this.state.count
    shop.cart.add( product )
    shop.toast( `
    <div><i class="icon icon-basket"></i> ${product.count} VE ${product.desc.short_des}</div>
    <div class="f5 ttu white-80">${product.count * product.unit_multi} Stück, ${formatPrice( product.count * product.price )} €</div>
    `, "success", false, "bottom" )
  }
  
  componentDidCatch( error, errorInfo ) {
    // not supported in this React Version
    console.warn( "Image fail", { props: this.props, error }, errorInfo )
    this.setState( { error: true } )
  }
  
  onMouseEnter = () => {
    if ( this.props.product.img_srcs.length <= 1 ) return
    this.setState( { imageIndex: 1 } )
  }
  
  onMouseLeave = () => {
    if ( this.props.product.img_srcs.length <= 1 ) return
    this.setState( { imageIndex: 0 } )
  }
  
  render() {
    const { error, imageIndex, count } = this.state
    if ( error ) return null
    
    let { product, sm, md, xs, lg } = this.props
    const hasRabatt = product.pinfos && product.pinfos.zuab !== "0"
    return (
      <Col {...{ sm, md, xs, lg }}
           className="product product-col product-col-detail">
        <div className="content relative" style={{ paddingBottom: `${shop.session ? "55px" : "16px"}` }}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}
        >
          <Badge product={product}/>
          {hasRabatt && <div className="badge red">{product.pinfos.zuab}%</div>}
          <section className="product-section">
            <div className="caption">
              <div className="brand"><Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link></div>
            </div>
          </section>
          
          {/*Image*/}
          <section className="product-image-container">
            <div key={imageIndex} className="image tc animated fadeIn duration-1200">
              <Link to={`/product/${product.map_id}`}
              >
                <img
                  src={product.img_srcs[ imageIndex ] && product.img_srcs[ imageIndex ].img_src_medium}
                  alt="..."
                  title={product.title}
                  className="img-responsive "/>
              </Link>
            </div>
          </section>
          
          <section className="product-section">
            <Link to={`/product/${product.map_id}`} className={"hover-black-80 black"}>
              <div className="description">
                <div>{product.article_nr}
                  {shop.session && <span>{product.getNotice( { size: "small" } )}</span>}</div>
              </div>
              <div className="title ">{product.title}</div>
            </Link>
          
          </section>
          
          
          <div className="absolute top-0 right-0 pt2 pr2">
            <ButtonLove
              className="fl"
              list={shop.orderlist.default}
              elementInActive={<Button className={"btn-love circular"}><i className="icon icon-heart-empty"/></Button>}
              elementActive={<Button className={"btn-love circular"}><i className="icon icon-heart"/></Button>}
              product={product}/>
          
          </div>
          
          {/*Product Description */}
          {shop.session &&
            <section className="product-section product-bottom ">
              <div className="price fl" title={translate( "misc.price_a_piece" )}>
                {hasRabatt && <div className="rabatt"><Price className="strike f6 ">{product.pinfos.brutto}</Price></div>}
                <Price className={`f4 b ${hasRabatt && "red"}`}>{product.price}</Price>
              </div>
              
              <div className="quantity tr black-60">
                {translate( "shop.VE" )} {product.unit_multi} {translate( "cart.piece" )}
                {/*<Quantity quantities={product.quantities}/>*/}
              </div>
              
              <div className="actions absolute bottom-0 left-1 right-1 pt3 overflow-hidden">
                
                
                <div className={"cb w-100 pt3"}>
                  <InputGroup contiguous>
                    <InputGroup.Section>
                      <Button onClick={() => {
                        this.setCount( count - 1 )
                      }
                      }>-</Button>
                    </InputGroup.Section>
                    <InputGroup.Section>
                      <Button onClick={() => {
                        this.setCount( count + 1 )
                      }
                      }>+</Button>
                    </InputGroup.Section>
                    
                    <InputGroup.Section grow>
                      <FormInput
                        onChange={e => {
                          this.setCount( e.target.value )
                        }
                        }
                        className={"tc"}
                        type="text" value={count}/>
                    </InputGroup.Section>
                    <InputGroup.Section>
                      <Button
                        type="primary"
                        title={"Klicken zum Bestellen"} className="fr" onClick={() => {
                        this.addToCart()
                      }}> <i className="icon icon-basket"/> </Button>
                    </InputGroup.Section>
                  </InputGroup>
                
                
                </div>
              </div>
            </section>
          }
        </div>
      </Col>
    )
  }
}

ProductColDetail.defaultProps = {
  xs: "1", sm: "1", md: "1/2", lg: "1/3",
}

ProductColDetail.propTypes = {
  product: PropTypes.object, xs: PropTypes.string, sm: PropTypes.string, md: PropTypes.string, lg: PropTypes.string,
}

export default ProductColDetail



// WEBPACK FOOTER //
// ./src/components/Product/ProductColDetail.js